import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import InfoButton from 'js/components/button/info-button';
import SVGImage from 'js/components/svg-image/svg-image';
import styles from './jumbo-radio.module.scss';

let instanceId = 0;

const JumboRadio = ({ options, selectedValue, onChange }) => {
    const [thisInstanceId, setThisInstanceId] = useState('');

    useEffect(() => {
        instanceId += 1;
        setThisInstanceId(`jumbo-radio-${instanceId}`);
    }, []);

    return (
        <div className={styles.options}>
            {options.map(
                ({
                    label,
                    value,
                    icons: [activeIcon, inactiveIcon],
                    info,
                    extra,
                }) => {
                    const isChecked = selectedValue === value;

                    return (
                        <div className={styles.option} key={value}>
                            <input
                                id={`${thisInstanceId}-${value}`}
                                type="radio"
                                checked={isChecked}
                                value={value}
                                onChange={() => onChange(value)}
                            />

                            <label
                                htmlFor={`${thisInstanceId}-${value}`}
                                className={styles['option-button']}
                            >
                                <div className={styles.container}>
                                    <div className={styles['icon-container']}>
                                        <SVGImage
                                            className={styles.icon}
                                            src={
                                                isChecked
                                                    ? activeIcon
                                                    : inactiveIcon
                                            }
                                        />
                                    </div>

                                    {label ? (
                                        <div className={styles.label}>
                                            {label}
                                        </div>
                                    ) : null}

                                    {info ? (
                                        <div className={styles.info}>
                                            <InfoButton placement="bottom-end">
                                                {info}
                                            </InfoButton>
                                        </div>
                                    ) : null}
                                </div>

                                {extra ? (
                                    <div className={styles.extra}>{extra}</div>
                                ) : null}
                            </label>
                        </div>
                    );
                },
            )}
        </div>
    );
};

export default JumboRadio;

JumboRadio.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
            ]).isRequired,
            icons: PropTypes.arrayOf(PropTypes.string).isRequired,
            info: PropTypes.node,
            extra: PropTypes.node,
        }),
    ).isRequired,
    selectedValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
};
